export function isBase64(str) {
    try {

        return str.toString().startsWith('data:image/')
        // Base64 string should be divisible by 4
        if (str.length % 4 !== 0) {
            return false;
        }

        // Regex to match base64 pattern
        const base64Pattern = /^[A-Za-z0-9+/]+={0,2}$/;

        // Test the string against base64 pattern
        if (!base64Pattern.test(str)) {
            return false;
        }

        // Attempt decoding to verify it's valid base64
        atob(str);
        return true;
    } catch (e) {
        return false;
    }
}
